// eslint-disable-next-line import/prefer-default-export
export const ERROR_TYPE__REQUIRED = 'required';
